module.exports = __webpack_public_path__ + "img/silvia.93bfba15.png";